import { CacheProvider, useCache } from '@elfsight/widget-utils';
import { meta } from '../../meta';
import { Data } from './Data';

export function DataWithCache(props) {
  return (
    <CacheProvider prefix={meta.appName}>
      <DataWithCacheInner {...props} />
    </CacheProvider>
  );
}

function DataWithCacheInner(props) {
  const cache = useCache();
  return <Data {...props} cache={cache} />;
}
